import { get, toQueryString } from '../axios'
import { paginated } from '../zod/pagination'
import { activity, ActivityQuery } from './activity'

export function fetchActivities({ query }: { query?: ActivityQuery } = {}) {
    return get(paginated(activity), '/activities' + `?${toQueryString(query || {})}`)
}
